import { createSlice } from "@reduxjs/toolkit";

export const initialDataSlice = createSlice({
  name: "initialData",
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startInitialData: (state) => { state.isLoading = true; },
    setInitialData: (state, { payload: { data = null, error = null }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startInitialData, setInitialData } = initialDataSlice.actions;
